import { YHDrawer } from "@components/YhDrawer";
import YhNotice from "@src/components/YhNotice";
import { IMdNoticeFields } from "../NoticeTypes";
import { useNoticeModel } from "./summaryModel";
import React from "react";


export function DetailDrawer() {
    const { drawerVisible: visible, setPreviewDisabled, setDrawerVisible, previewData, previewDisabled } = useNoticeModel();
    const onCancel = () => {
        setDrawerVisible(false);
        setPreviewDisabled(false)
    }
    return (
        <YHDrawer
            {...{
                title: "公告详情",
                visible,
                onCancel,
                showFooter: false
            }}
        >
            <YhNotice content={previewData as IMdNoticeFields} disabled={previewDisabled} />
        </YHDrawer>
    )
}